/*
 * @Author: lishiqiao
 * @Date: 2021-12-24 10:34:40
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-10-25 13:47:17
 */
import Vue from 'vue'
import App from './App.vue'
import MobileApp from '../mobile/Mobile.vue'
import router from '../../modules/pc/router'
import Cookies from 'js-cookie'
import '../../assets/Alibaba-PuHuiTi/Alibaba-PuHuiTi.less';
import ElementUI from 'element-ui';

import {
  Button,
  Loading,
  Message,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Dialog,
  Collapse,
  CollapseItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Carousel,
  CarouselItem
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
// axios 基于 Promise 的 HTTP 请求插件
import axios from '../../axios/index'
Vue.prototype.$axios = axios
// 全局自定义变量、方法
import $ from '../../utils/methods/methods'
Vue.prototype.$ = $
import store from '../../store/index'
import * as filters from '../../utils/filters';
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  // error: './static/error.png', //图片加载失败显示的图片
  // loading: './static/loading.gif' // 图片加载中显示的图片
})

Vue.component(Button.name, Button);
Vue.component(Dialog.name, Dialog);
Vue.component(Collapse.name, Collapse);
Vue.component(CollapseItem.name, CollapseItem);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);


Vue.use(Loading.directive);
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Carousel)
Vue.use(CarouselItem)

Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;

import rem from '../../utils/rem/rem'
Vue.use(rem)
import i18n from '../../lang/index' // internationalization

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

import { VueJsonp } from 'vue-jsonp';
import { businessStatis } from './../../axios/commonApi';
Vue.use(VueJsonp)
Vue.config.productionTip = false
Vue.prototype.businessStatis = businessStatis
new Vue({
  router,
  i18n,
  store,
  render: h => h(window.isMobile() ? MobileApp : App),
}).$mount('#app')